"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
const delay = (delayTime) => new Promise((resolve) => {
    setTimeout(resolve, delayTime);
});
exports.delay = delay;
